import AbstractInspector from "./abstract-inspector";
import CharacterInspector from "./character-inspector";
import PuzzleInspector from "./puzzle-inspector";
import StartupImageInspector from "./startup-image-inspector";
import SoundInspector from "./sound-inspector";
import TileInspector from "./tile-inspector";
import ZoneInspector from "./zone-inspector";
import PaletteInspector from "./palette-inspector";
import SaveGameInspector from "./save-game-inspector";
import CoverageInspector from "./coverage-inspector";

export {
	AbstractInspector,
	CharacterInspector,
	PuzzleInspector,
	StartupImageInspector,
	SoundInspector,
	TileInspector,
	ZoneInspector,
	PaletteInspector,
	SaveGameInspector,
	CoverageInspector
};
